var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4975 0.5H11.5018C14.0525 0.5 15.4925 1.94675 15.5 4.4975V11.5025C15.5 14.0525 14.0525 15.5 11.5018 15.5H4.4975C1.94675 15.5 0.5 14.0525 0.5 11.5025V4.4975C0.5 1.94675 1.94675 0.5 4.4975 0.5ZM8.0368 12.395C8.36005 12.395 8.6293 12.155 8.6593 11.8325V4.19C8.6893 3.9575 8.57755 3.72425 8.37505 3.5975C8.1643 3.47 7.9093 3.47 7.70755 3.5975C7.5043 3.72425 7.39255 3.9575 7.4143 4.19V11.8325C7.45255 12.155 7.7218 12.395 8.0368 12.395ZM11.4875 12.395C11.8025 12.395 12.0718 12.155 12.11 11.8325V9.3725C12.1318 9.13175 12.02 8.9075 11.8168 8.78C11.615 8.6525 11.36 8.6525 11.15 8.78C10.9468 8.9075 10.835 9.13175 10.865 9.3725V11.8325C10.8951 12.155 11.1643 12.395 11.4875 12.395ZM5.16427 11.8325C5.13427 12.155 4.86502 12.395 4.54177 12.395C4.21927 12.395 3.94927 12.155 3.92002 11.8325V6.65C3.89752 6.41675 4.00927 6.185 4.21252 6.0575C4.41427 5.93 4.67002 5.93 4.87252 6.0575C5.07427 6.185 5.18752 6.41675 5.16427 6.65V11.8325Z",
    fill: "#362269"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDashboard);
export default __webpack_public_path__ + "static/media/ActiveDashboard.bcb72d0ac5c50264051276c19262c689.svg";
export { ForwardRef as ReactComponent };